import { action, observable, makeAutoObservable, set, computed } from "mobx";

export default class MenuInfo {
  @observable menuId: string = "";
  @observable upperMenuId: string = "";
  @observable menuLevel: number = 0;
  @observable menuNm: string = "";
  @observable menuPath: string = "";
  @observable authorCodes!: string;

  @observable active: boolean = false;
  @observable opened: boolean = false;

  @observable children: MenuInfo[]|undefined;

  public constructor(data:MenuInfo) {
    makeAutoObservable(this);
    set(this, data);
  }

  public getMenuId() {
    return this.menuId;
  }

  public setMenuId(menuId: string) {
    this.menuId = menuId;
  }

  public getUpperMenuId() {
    return this.upperMenuId;
  }

  public setUpperMenuId(upperMenuId: string) {
    this.upperMenuId = upperMenuId;
  }

  public getMenuLevel() {
    return this.menuLevel;
  }

  public setMenuLevel(menuLevel: number) {
    this.menuLevel = menuLevel;
  }

  public getMenuNm() {
    return this.menuNm;
  }

  public setMenuNm(menuNm: string) {
    this.menuNm = menuNm;
  }

  public getMenuPath() {
    return this.menuPath;
  }

  public setMenuPath(menuPath: string) {
    this.menuPath = menuPath;
  }

  public isActive() {
    return this.active;
  }

  @action
  public setActive(active: boolean) {
    this.active = active;
  }

  public isOpened() {
    return this.opened;
  }

  @action
  public setOpened(opened: boolean) {
    this.opened = opened;
  }

  @action
  public setChildren(children: MenuInfo[]) {
    this.children = children;
    return this;
  }

  @computed
  public getAuthorities() {
    if(this.authorCodes) {
      return this.authorCodes.split(',');
    }
    else
      return ['ROLE_ANONYMOUS'];
  }
}
